<template>
    <el-dialog :title="dialogName" :visible.sync="dialogVisible" :close-on-click-modal="false" :modal-append-to-body="true" :append-to-body="true" width="800px">
      <div class="main-box">
          <img :src="imgUrl" style="height: 100%;width: 100%">
      </div>
      <div slot="footer" class="dialog-footer">
        <xr-button type="default" @click.native="dialogVisible = false">取消</xr-button>
      </div>
    </el-dialog>
</template>

<script>
export default {
  name: 'imgView',
  data() {
    return {
      dialogVisible: false,
      dialogName: '预览',
      imgUrl: '',
    }
  },
  methods: {
    //初始化页面
    init(resourceId) {
      this.dialogVisible = true;
      this.imgUrl = process.env.FILE_URL +'/web/viewResource/' + resourceId;
    },
    //重置
    resetTemp() {
      this.imgUrl = '';
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/XrResource/img-view.vue